import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import SearchCodeMapping from './component/SearchCodeMapping/SearchCodeMapping';
import CreateCodeMapping from './component/CreateCodeMapping/CreateCodeMapping';
import SubHeader from '../../Header/SubHeader';
import UserRoles from '../../../constants/userRoles';

import './CodeMapping.css';

const CodeMapping = () => {
  const optionLabels = {
    Search: 'Search',
    Create: 'Create'
  }
  const [menuOptions, setMenuOptions] = useState([
    {
      index: 0,
      label: optionLabels.Search,
      default: true,
    },
    {
      index: 1,
      label: optionLabels.Create,
    }
  ]);
  const navigate = useNavigate();
  const user = useSelector((state) => state.User);
  const [selectedMenu, setSelectedMenu] = useState(menuOptions[0]);
  const [codeMappingId, setCodeMappingId] = useState();
  const [codeMappingType, setCodeMappingType] = useState();
  const [mappingResponse, setMappingResponse] = useState('');
  const [accessDenied, setAccessDenied] = useState(false);
  useEffect(() => () => setMappingResponse(''));

  const handleSelected = (option, response=null) => {
    if (response) setMappingResponse(response);
    setSelectedMenu(option);
  };

  const handleEditCodeMapping = (_codeMappingId, _codeMappingType) => {
    setCodeMappingId(_codeMappingId);
    setCodeMappingType(_codeMappingType);
    setSelectedMenu(menuOptions.find(m => m.label === optionLabels.Create));
  };

  const handleClearEdit = () => {
    setCodeMappingId(null);
    setSelectedMenu(menuOptions.find(m => m.label === optionLabels.Search));

  };

  useEffect(() => {
    if (user) {
      console.log('CodeMapping.jsx: Current User Role:', user.Role);
      if (user.Role !== UserRoles.Admin && user.Role !== UserRoles.Owner && user.Role !== UserRoles.WFM) {
        console.log('CodeMapping.jsx: User does not have Admin access and Owner access and WFM access.');
        setAccessDenied(true);
      }

      if (user.Role === UserRoles.WFM && user.Role !== UserRoles.Admin && user.Role !== UserRoles.Owner) {
        if (!(user.Claims.CodeMappingEnterpriseSearch) && (user.Claims.CodeMappingEnterpriseCreate)) {
          const filteredMenu = menuOptions.filter(option => option.label !== optionLabels.Search);
          setMenuOptions(filteredMenu);
          setSelectedMenu(filteredMenu[0]);
        }
        else if (!(user.Claims.CodeMappingEnterpriseCreate) && user.Claims.CodeMappingEnterpriseEdit) {
          setMenuOptions([...menuOptions.filter(option => option.label !== optionLabels.Create), {
            ...menuOptions.find(option => option.label === optionLabels.Create),
            isDisabled: true }]);
        }
        else if (!(user.Claims.CodeMappingEnterpriseCreate) && !(user.Claims.CodeMappingEnterpriseEdit)) {
          const filteredMenu = menuOptions.filter(option => option.label !== optionLabels.Create);
          setMenuOptions(filteredMenu);
        }

        if (!(user.Claims.CodeMappingEnterpriseSearch) && !(user.Claims.CodeMappingEnterpriseCreate)) {
          console.log('CodeMapping.jsx: User does not have Search access and Create access.');
          setAccessDenied(true);
        }
      }
    }
  }, [user]);

  return (
    (() => {
        if (accessDenied) {
          return navigate(
            '/AccessDenied'
          );
        }
        
        if (menuOptions.length) {
          return (
            <>
              <SubHeader options={menuOptions}
                handleSelected={handleSelected}
                selectedOptions={selectedMenu.label}
              />
              {selectedMenu.label === optionLabels.Create ?
                <CreateCodeMapping codeMappingId={codeMappingId} codeMappingTypeToEdit={codeMappingType} handleClearEdit={handleClearEdit} handleSelected={handleSelected} /> :
                <SearchCodeMapping handleEditCodeMapping={handleEditCodeMapping} mappingResponse={mappingResponse} />
              }
            </>);
        }

        return null;
    })()
  );
};

export default CodeMapping;
